module.exports = __webpack_public_path__ + "img/w11.303adc50.svg";